import { ApiResponse } from "../../apiResponse";
import Axios from "../../axios";

export function sessionLearnerEvaluations(
  id: string | number,
  sessionEvaluations: object
): Promise<ApiResponse> {
  return Axios.post(
    `v1/tutors/sessions/${id}/session_evaluations/`,
    sessionEvaluations
  );
}
